import $axios from "./axios";

/* ==================== LOGIN ==================== */
export const fetchLogin = (data) => {
  return $axios.$post("/login", data);
};

/* ==================== PHONE TOPUP ==================== */
export const fetchCheckMsisdn = (phoneNumber) => {
  return $axios.$get("/card-media/check_msisdn", { params: { msisdn: phoneNumber } });
};

export const fetchCardPhoneInfo = (provider) => {
  return $axios.$get("/card-media/topup_list_amount", { params: { provider } });
};

export const fetchProviderTelecom = () => {
  return $axios.$get("/card-media/provider_telecom");
};

export const processPhonePayment = (dataPayment) => {
  return $axios.$post("/card-media/payment_telecom", dataPayment);
};

/* ==================== DATA PACKAGE ==================== */
export const fetchCardDataInfo = (provider) => {
  return $axios.$get("/card-media/card_data_info", { params: { provider } });
};

export const processDataPayment = (dataPayment) => {
  return $axios.$post("/card-media/payment_data", dataPayment);
};

/* ==================== CARD PHONE (mua the dien thoai) ==================== */
export const fetchCheckCodeVoucher = (code) => {
  return $axios.$get("/card/check_code_voucher", { params: { codeVoucher: code } });
};

export const getVouchersByOrder = (data) => {
  return $axios.$post("/voucher/getVoucherByOrder", data);
};

export const checkVoucher = (data) => {
  return $axios.$post("/voucher/getVoucher", data);
};

export const processCardPhonePayment = (dataPayment) => {
  return $axios.$post("/card-media/payment_card_phone", dataPayment);
};

export const fetchDownloadProduct = (provider) => {
  return $axios.$get("/card-media/list_download_product", { params: { provider } });
};

/* ==================== GAME CARD ==================== */
export const fetchProviderGame = () => {
  return $axios.$get("/card-media/provider_game");
};

export const processGamePayment = (dataPayment) => {
  return $axios.$post("/card-media/payment_game", dataPayment);
};

/* ==================== HISTORY ==================== */
export const fetchTransactionHistory = (fromDate, toDate, page, pageSize, orderCode = null) => {
  const params = { page, pageSize };
  if (orderCode) {
    params.ordercode = orderCode;
  } else if (fromDate && toDate) {
    params.fromDate = fromDate;
    params.toDate = toDate;
  }
  return $axios.$get("/order-card/findByAllUser", {
    params,
  });
};

export const fetchTransactionDetail = (id) => {
  return $axios.$get("/order-card/findByCodeUser", { params: { id } });
};

export const fetchPaymentInfo = (data) => {
  return $axios.$get("/payment/payment_info", { params: data });
};

/* ==================== PAYMENT ==================== */
export const fetchPaymentHandle = (data) => {
  return $axios.$post("/payment/paymentHandle", data);
};

export const fetchPaymentBankInit = (data) => {
  return $axios.$post("/card-media/payment-mbvbank", data);
  // return $axios.$post("/card-media/wallet-payment/VTCPAY", data);
};

/* ==================== OTHER ==================== */
export const fetchAdvImage = () => {
  return $axios.$get("/card-media/adv_image");
};
